import { type AgencyLink, AgencyLinkType } from '~/common/types';

export const linkTypeMap: { [key in AgencyLinkType]: string } = {
  [AgencyLinkType.Nda]: 'NDA',
  [AgencyLinkType.Letterhead]: 'Letterhead',
  [AgencyLinkType.Other]: 'Other',
};

export type TFormValues = Pick<AgencyLink, 'title' | 'description' | 'url' | 'type' | 'isPrivate'> & {
  agencySubGeometryId: string;
};

export const items = Object.values(AgencyLinkType).map((type) => ({
  value: type,
  label: <div className="text-xs">{linkTypeMap[type]}</div>,
}));
